<template>
  <div class="chat-ai-check" ref="chatAiCheck" :style="`align-items: ${ message.aiRespFlag == 0 ? 'self-end' : 'self-start'}`">
    <div class="message-wrapper">
      <div class="conversation-message">
        <!-- <span class="'message-title" v-html="formattedText"></span> -->
        <div class="conversation-message-ai-top" @click="isOpen = !isOpen" v-if="!isLoding">
          <div class="conversation-message-ai-top-text"> 
            {{ $t('use_list_tab1') }}
          </div>
          <i class="iconfont icon-icon_arrowsdown" :style="`transform: rotate(${isOpen ? '180deg' : '0deg'})`"></i>
        </div>
        <div class="ai-lists" v-if="isOpen">
          <div class="ai-list-item" v-for="(item, index) in lists" :key="'ai-list-item-' + index" @click="onItemClick(item)">
            <div class="ai-list-item-error-top" :style="`background-color: ${item.type < 4 ? '#EAF5FC' : '#F9DBD3'}`">
              <div class="ai-list-item-error-top-text">
                {{ getErrorType(item.type) }}
              </div>
              <div class="ai-list-item-top-expand" v-if="expandMap[item.page + '_' + item.index] != undefined" @click.stop="onExpand(item.page, item, item.index)">
                <div class="ai-list-item-top-expand-text">
                  {{ expandMap[item.page + '_' + item.index] ? $t('ai_chat_collapse') : $t('ai_chat_expand') }}
                </div>
                <i class="iconfont icon-icon_arrowsdown" :style="`transform: rotate(${expandMap[item.page + '_' + item.index] ? '180deg' : '0deg'})`"></i>
              </div>
            </div>
            <div class="ai-list-item-error-content">
              <div class="ai-list-item-error-content-title">
                {{ $t('original') }}
              </div>
              <div :class="expandMap[item.page + '_' + item.index] ? 'ai-list-item-error-content-text-expand' : 'ai-list-item-error-content-text'">
                {{ item.original }}
              </div>
              <div class="ai-list-item-error-content-title">
                {{ $t('art_entry_header_title3') }}
              </div>
              <div :class="expandMap[item.page + '_' + item.index] ? 'ai-list-item-error-content-text-expand' : 'ai-list-item-error-content-text'">
                {{ item.translate }}
              </div>
              <div class="ai-list-item-error-content-title">
                {{ $t('aiProofreading_check') }}
              </div>
              <div :class="expandMap[item.page + '_' + item.index] ? 'ai-list-item-error-content-text-expand' : 'ai-list-item-error-content-text'">
                {{ item.check }}
              </div>
            </div>
          </div>
          <div class="no-result" v-if="!isLoding && lists.length == 0">
            <div class="ai-list-item-error-top-text">
                {{ $t('ai_check_no_result') }}
              </div>
          </div>
        </div>
        <div class="ai-check-loading" v-if="isLoding">
          <ChatLoading :size="20" />
          <span class="message-normal-title">{{ currentTextTips }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
const { t } = useI18n()
import ChatLoading from "@/components/PDFChatComponents/ChatLoading.vue"
import eventBus from 'vue3-eventbus'
import { type Message} from '@/data/chat/Message';

let call = defineEmits(["updateContentHeight", "aICheck"])

let currentTextTips = ref(t('chat_auto_checking'))
let currentText = ref("")
let isLoding = ref(true)
let currentIndex = 0
let isOpen = ref(true)
let lists = ref<any[]>([])
let expandMap = ref({})
let textCanvas = ref<HTMLDivElement | null>(null)
let chatAiCheck = ref<HTMLDivElement | null>(null)
let aiProofreadingJson = ref() // 下载后的json数据
interface Props {
  message: Message // 内容结构体
  index: number
  type?: number // 2 代表ai 翻译
}
const props = defineProps<Props>()

watch(currentText, () => {
  call("updateContentHeight")
},{
  deep: true
});


watch(() => props.message, (newParams, oldParams) => {
  if (oldParams.chatId == -1 && newParams.chatId > 0) {
    // updataContent()
  }
  if (props.message.msgJsonContent && typeof props.message.msgJsonContent === 'string' && props.message.msgJsonContent != '') {
    aiProofreadingJson.value = undefined
    loadAIProofreadingJson(props.message.msgJsonContent)
  }
},{
  deep: true
});

const getErrorType = (type: number) => {
  if (type > 0) {
    return t(`aiProofreading_error_type_${type}`)
  }
  return ""
}

const onExpand = (pageIndex: number, item: any, index: number) => {
  if (expandMap.value[pageIndex + '_' + index]) {
    expandMap.value[pageIndex + '_' + index] = !expandMap.value[pageIndex + '_' + index]
  } else {
    expandMap.value[pageIndex + '_' + index] = true
  }
  console.log('xs expandMap', expandMap.value)
}

function aiPollingSort(json) {
  
}

// 加载json处理
const loadAIProofreadingJson = async(urlName: string) => {
  if (aiProofreadingJson.value) {
    return
  }
  // 加载完json后不是立马渲染textLayer，而是需要检查是否渲染，会存在json先加载完，也有可能json后加载完
  try {
    // 通过json 文件获取json 数据
    console.log('xs loadAIProofreadingJson===1111', props.message)
    // let url = new URL(`${useRuntimeConfig().public.config.VITE_PDF_DOWNLOAD_API_URL}pdf/${urlName}`)
    // console.log('xs loadAIProofreadingJson===', url, urlName, props.message.msgJsonContent)

    aiProofreadingJson.value = props.message.msgJsonContent ? JSON.parse(props.message.msgJsonContent) : []
    console.log('xs loadAIProofreadingJson===1111', aiProofreadingJson.value)
    getLists()
  } catch (error) {
    console.log('xs loadAIProofreadingJson===error', error)
  }
}

function getLists() {
  if (aiProofreadingJson.value) {
    let newList = []
    let textMouseMap = {}
    let contents = aiProofreadingJson.value as []
    // 获取父节点宽度
    let parentWidth = chatAiCheck.value?.clientWidth
    console.log('xs getLists', contents)
    for (let index = 0; index < contents.length; index++) {
      // 页数
      const elements = contents[index];
      if (elements && elements.length > 0) {
        let j = 0
        elements.forEach((element: any) => {
          let isExpand = false
          if (element.type > 0 && element.type < 10) {
            element.page = index + 1
            element.index = j
            newList.push(element)
            // 这里判断三种文字是否超过文本宽度
            if (textCanvas.value){
              if (element.original){
                let textWidth = getTextWidth(element.original)
                console.log('xs textWidth', textWidth, parentWidth, element.original)
                if (textWidth > parentWidth) {
                  isExpand = true
                }
              }
              if (element.translate){
                let textWidth = getTextWidth(element.translate)
                if (textWidth > parentWidth) {
                  isExpand = true
                }
              }
              if (element.check){
                let textWidth = getTextWidth(element.check)
                if (textWidth > parentWidth) {
                  isExpand = true
                }
              }
            }
            if (isExpand) {
              textMouseMap[element.page + "_" + j] = false
            }
          }
          j += 1
        })
      }
    }
    newList = newList.filter((item) => {
      return item.bbox
    })
    newList = newList.sort((a, b) => {
      // 先按 page 排序
      if (a.page !== b.page) {
        return a.page - b.page;
      }
      // 如果 page 相同，再按 index 排序
      return a.type - b.type;
    })
    expandMap.value = textMouseMap
    lists.value = newList
    isLoding.value = false
  }
}

function getTextWidth(text: string, fontStyle = {}) {

  if (!textCanvas.value){
    return 0
  }

  let span = textCanvas.value
  span.style.visibility = 'hidden';
  span.style.whiteSpace = 'nowrap';
  span.style.position = 'absolute';
  span.style.left = '-9999px';
  
  // 应用字体样式
  Object.assign(span.style, {
    fontFamily: fontStyle.fontFamily || 'Arial',
    fontSize: fontStyle.fontSize || '14px',
    fontWeight: fontStyle.fontWeight || 'normal',
    fontStyle: fontStyle.fontStyle || 'normal',
    letterSpacing: fontStyle.letterSpacing || 'normal'
  });
  
  span.textContent = text;
  document.body.appendChild(span);
  
  const width = span.getBoundingClientRect().width;
  document.body.removeChild(span);
  return width;
}

function onItemClick(item: any) {
  call("aICheck", item)
}

const enableMouseEvents = () => {
  console.log('xs enableMouseEvents')
  getLists()
}

onMounted(()=>{
  call("updateContentHeight")
  
  eventBus.on('enableMouseEvents', enableMouseEvents)
  textCanvas.value = document.createElement('div')
  if (props.message.msgJsonContent && typeof props.message.msgJsonContent === 'string' && props.message.msgJsonContent != '') {
    loadAIProofreadingJson(props.message.msgJsonContent)
  }
})

onUnmounted(()=>{
  eventBus.all.delete('enableMouseEvents')
})

</script>

<style lang="less" scoped>
.chat-ai-check {
  width: 100%;
  display: flex;
  flex-direction: column;
  .message-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 4px;
    margin-bottom: 4px;
    position: relative;
    width: 100%;
    .conversation-message {
      border-radius: 8px;
      font-size: 14px;
      overflow-wrap: break-word;
      box-sizing: border-box;
      width: 100%;
      .conversation-message-ai-top {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        background: #F5F5F5;
        border-radius: 4px 4px 4px 4px;
        padding: 5px 5px;
        .conversation-message-ai-top-text {
          color: #2590E1;
          font-size: 12px;
          font-weight: bold;
          margin-left: 5px;
        }
        .icon-icon_arrowsdown {
          font-size: 12px;
          margin-left: 5px;
          color: #2590E1;
        }
      }
      .ai-lists {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        .ai-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          .ai-list-item-error-top {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            min-height: 40px;
            margin-top: 10px;
            border-radius: 4px 4px 4px 4px;
            // padding: 0 10px;
            background-color: #EAF5FC;
            .ai-list-item-error-top-text {
              color: var(--text-color);
              font-size: 12px;
              font-weight: bold;
              margin-left: 10px;
              max-width: 60%;
              padding: 5px 0;
            }
            .ai-list-item-top-expand {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-end;
              cursor: pointer;
              .ai-list-item-top-expand-text {
                color: var(--text-color);
                font-size: 12px;
                font-weight: bold;
                margin-right: 5px;
              }
              .icon-icon_arrowsdown {     
                font-size: 12px;
                margin-right: 10px;
                color: var(--text-color);
              }
            }
          }
          .ai-list-item-error-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            margin-top: 1px;
            background-color: #F5F5F5;
            border-radius: 4px 4px 4px 4px;
            padding-bottom: 13px;
            cursor: pointer;
            .ai-list-item-error-content-title {
              color: #8C8C8C;
              font-size: 12px;
              font-weight: bold;
              width: calc(100% - 20px);
              padding: 5px 0;
              margin-left: 10px;
            }
            .ai-list-item-error-content-text {
              color: var(--text-color);
              font-size: 12px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              width: calc(100% - 20px);
              padding: 5px 0;
              margin-left: 10px;
            }
            .ai-list-item-error-content-text-expand {
              color: var(--text-color);
              font-size: 12px;
              width: calc(100% - 20px);
              padding: 5px 0;
              margin-left: 10px;
            }
          }
        }
        .no-result {
          display: flex;
          flex-direction: column;
          width: 100%;
          background-color: #F5F5F5;
          border-radius: 4px 4px 4px 4px;
          padding: 5px 0px;
          margin-top: 10px;
          .ai-list-item-error-top-text {
            color: var(--text-color);
            font-size: 12px;
            margin-left: 10px;
          }
        }
      }

      .ai-check-loading {
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: #F5F5F5;
        border-radius: 4px 4px 4px 4px;
        padding: 5px 5px;
      }
      .message-title {
        color: #262626;
        .ul {
          list-style-position: inside; /* 将标记放在列表项内部 */
        }
      }
      .message-normal-title {
        color: #262626;
        font-size: 14px;
        line-height: 20px;
        margin-left: 6px;
      }
    }
  }
}
</style>
